export default __webpack_public_path__ + "static/media/coin.b8bc711d.svg";